(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function buildHeader() {
    // Desktop keeps the theme's normal header — this rebuild is mobile-only.
    if (!isMobile()) return;

    var columns = document.querySelector('#header-component .header__columns');
    if (!columns || columns.getAttribute('data-ae-header-built') === 'true') return;

    var drawer = columns.querySelector('header-drawer');
    var logo = columns.querySelector('.header-logo');
    var search =
      columns.querySelector('.search-action--hidden-on-menu') ||
      columns.querySelector('.search-action--hidden-on-drawer') ||
      columns.querySelector('.search-action');
    var account = columns.querySelector('.ae-account-wrap');
    var cart = columns.querySelector('cart-drawer-component') || columns.querySelector('.action__cart');

    // Header hasn't fully rendered yet — wait for the next mutation.
    if (!drawer || !logo) return;

    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'ae-header-back-btn';
    back.setAttribute('aria-label', 'Go back');
    back.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
    back.addEventListener('click', function () {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    });

    [back, drawer, logo, search, account, cart].forEach(function (el) {
      if (el) {
        el.classList.add('ae-header-active');
        columns.appendChild(el);
      }
    });

    columns.setAttribute('data-ae-header-built', 'true');
  }

  // Mobile PDP: move the purchase panel (seller card, quantity, Buy now / Add to
  // cart) up so it sits right after the price, before the "Premium Quality" bullet
  // list — instead of its normal spot near the bottom of the page. Desktop layout
  // is untouched; if the viewport grows back past the breakpoint the panel is
  // restored to its original position via the placeholder comment left behind.
  function movePurchasePanelMobile() {
    var priceBlock = document.querySelector('.product-information__grid--aliexpress product-price');
    var purchase = document.querySelector('.product-information__grid--aliexpress .product-information__purchase');
    if (!priceBlock || !purchase) return;

    if (isMobile()) {
      if (purchase.getAttribute('data-ae-mobile-moved') === 'true') return;
      var placeholder = document.createComment('ae-purchase-panel-original-position');
      purchase.parentNode.insertBefore(placeholder, purchase);
      purchase._aePlaceholder = placeholder;
      priceBlock.insertAdjacentElement('afterend', purchase);
      purchase.setAttribute('data-ae-mobile-moved', 'true');
    } else if (purchase.getAttribute('data-ae-mobile-moved') === 'true') {
      if (purchase._aePlaceholder && purchase._aePlaceholder.parentNode) {
        purchase._aePlaceholder.parentNode.insertBefore(purchase, purchase._aePlaceholder);
        purchase._aePlaceholder.remove();
      }
      purchase.removeAttribute('data-ae-mobile-moved');
    }
  }

  // NOTE: moving <slideshow-controls> (the thumbnail strip) out of
  // <slideshow-component>/<media-gallery> was tried and reverted — the component
  // (assets/slideshow.js + assets/component.js) computes its `refs` by querying
  // only its own descendants, so relocating the thumbnails elsewhere in the DOM
  // silently breaks click-to-change-slide. Leave it in place; only visual (CSS)
  // repositioning within the gallery itself is safe for this component.

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      buildHeader();
      movePurchasePanelMobile();
    });
  }

  function init() {
    buildHeader();
    movePurchasePanelMobile();
    var target = document.getElementById('header-component');
    if (target && window.MutationObserver) {
      new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
    }
    // In case the viewport crosses the mobile breakpoint without a full reload.
    window.matchMedia(MOBILE_QUERY).addEventListener('change', schedule);
  }

  var WISHLIST_STORAGE_KEY = 'ae-wishlist-product-ids';

  function getWishlistIds() {
    try {
      return JSON.parse(window.localStorage.getItem(WISHLIST_STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlistIds(ids) {
    try {
      window.localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
      /* localStorage unavailable — ignore */
    }
  }

  function initWishlistToggle() {
    // <media-gallery> is a web component that manages its own subtree, so the
    // button lives as a sibling in its plain wrapper div instead of inside it.
    var wrapper = document.querySelector('.product-information__media');
    if (!wrapper || wrapper.querySelector('[data-ae-wishlist-toggle]')) return;

    var productId = document.querySelector('[data-product-id]');
    productId = productId ? productId.getAttribute('data-product-id') : null;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ae-gallery-wishlist-btn';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.setAttribute('data-ae-wishlist-toggle', '');
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7.5-4.5-10-9C.3 8.5 2 4 6 4c2 0 3.5 1 4 2.5C10.5 5 12 4 14 4c4 0 5.7 4.5 4 8-2.5 4.5-10 9-10 9z"/></svg>';

    var ids = getWishlistIds();
    if (productId && ids.indexOf(productId) !== -1) {
      btn.setAttribute('aria-pressed', 'true');
    }

    btn.addEventListener('click', function () {
      if (!productId) return;
      var currentIds = getWishlistIds();
      var index = currentIds.indexOf(productId);
      if (index === -1) {
        currentIds.push(productId);
        btn.setAttribute('aria-pressed', 'true');
      } else {
        currentIds.splice(index, 1);
        btn.setAttribute('aria-pressed', 'false');
      }
      setWishlistIds(currentIds);
    });

    wrapper.appendChild(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('DOMContentLoaded', initWishlistToggle);
  } else {
    init();
    initWishlistToggle();
  }
})();
